import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { ChevronDownIcon } from "../../../Assets/images/svgs";
import { Tooltip } from "@chakra-ui/react";

const OptionList = ({ name, Icon, options = [], onOptionClick = () => {}, customClassName = "", selected }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => setIsOpen((prev) => !prev);

  const handleOptionClick = (option) => {
    onOptionClick(option);
    if (!option.disabled) setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={`menu-container ${customClassName}`} ref={menuRef}>
      <div className="menu-btn" onClick={toggleMenu}>
        <div className="menu-label">
          {Icon && <Icon />}
          <span>{selected || name}</span>
        </div>
        <ChevronDownIcon className={`menu-chevron ${isOpen ? "expanded" : ""}`} />
      </div>
      <div className={`menu-items ${isOpen ? "expanded" : "collapsed"}`}>
        {options.map((option, index) => (
          <Tooltip isDisabled={!option.showTooltip} label={option.tooltipText} key={option.value || index} openDelay={200} closeDelay={100} >
            <div className={`menu-item ${option.disabled ? "disabled-option" : ""}`} onClick={() => handleOptionClick(option)}>
              <span>{option.label}</span>
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

export default OptionList;